const smartlingLanguages = {
    English: 'en-US',
    'French Canadian': 'fr-CA',
    French: 'fr-FR',
    Japanese: 'ja-JP',
    Korean: 'ko-KR',
    Spanish: 'es-LA',
    Mandarin: 'zh-CN',
    German: 'de-DE',
    Portuguese: 'pt-BR',
    Hindi: 'hi-IN',
    Polish: 'pl-PL',
    Italian: 'it-IT',
    Malay: 'ms-MY',
};
// This list of languages are the real supported languages, that includes default languages as
// fr or es.
const languages = {
    ...smartlingLanguages,
    French: 'fr',
    Korean: 'ko',
    Mandarin: 'zh-Hans',
    Spanish: 'es',
    Japanese: 'ja',
    German: 'de',
    Portuguese: 'pt',
    Hindi: 'hi',
    Polish: 'pl',
    Italian: 'it',
    Malay: 'ms',
};

const files = [
    'programs',
    'translation',
    'auth',
    'circles',
    'dashboard',
    'user',
    'validation',
    'providers',
    'shared',
    'goals',
    'retriage',
    'onboarding',
    'videoSessions',
    'admin',
    'assessments',
    'intakeForms',
    'dailyPause',
    'insuranceForm',
    'courses',
    'payments',
    'dependents',
    'benefits',
    'care',
    'messaging',
    'careNavigation',
    'vita',
];

export { smartlingLanguages, languages, files };
